import { Event } from "@planzone/events";
import { StateReducer } from "../types/stateReducer";

type SimplifiedStateReducer<State, M extends Event> = (
  state: State,
  data: M["data"],
) => State;

type ExtractEvent<Event, Type> = Event extends { type: Type } ? Event : never;

function createStateReducer<State, Type extends Event["type"] = Event["type"]>(
  initialState: State,
  map: {
    [Key in Type]?: SimplifiedStateReducer<State, ExtractEvent<Event, Key>>;
  },
  reduceDefault?: StateReducer<State, Event>,
): StateReducer<State, Event> {
  return (state = initialState, event) =>
    event.type in map
      ? // @ts-ignore
        map[event.type](state, event.data)
      : reduceDefault
        ? reduceDefault(state, event)
        : state;
}

export { createStateReducer };
